import { ref } from 'vue';

export default function useFormErrors() {
  const errors = ref(null);

  function clear() {
    errors.value = null;
  }

  function has(name) {
    if (!errors.value) {
      return false;
    }

    if (Array.isArray(name)) {
      for (const entry of name) {
        if (errors.value.hasOwnProperty(entry)) {
          return true;
        }
      }

      return false;
    }

    if (typeof name === 'string' && name.endsWith('*')) {
      const nameWithoutWildcard = name.slice(0, -1);
      const keys = Object.keys(errors.value);

      for (const key of keys) {
        if (key.startsWith(nameWithoutWildcard)) {
          return true;
        }
      }

      return false;
    }

    return errors.value.hasOwnProperty(name);
  }

  function hasSub(name) {
    if (!errors.value) {
      return false;
    }

    const keys = Object.keys(errors.value);

    for (const key of keys) {
      if (key.includes(name)) {
        return true;
      }
    }

    return false;
  }

  function get(name) {
    if (!errors.value) {
      return null;
    }

    if (Array.isArray(name)) {
      let mergeErrors = [];

      for (const entry of name) {
        if (!errors.value.hasOwnProperty(entry)) {
          continue;
        }

        mergeErrors = mergeErrors.concat(errors.value[entry]);
      }

      return mergeErrors.length > 0 ? mergeErrors : null;
    }

    return errors.value[name];
  }

  function setErrors(entry) {
    errors.value = entry;
  }

  function updateFromError(error) {
    if (typeof error === 'string' || !error || typeof error.response !== 'object') {
      return;
    }

    clear();

    if (!(error?.response?.status === 422) || !error?.response?.data?.error?.errors) {
      return;
    }

    setErrors(error.response.data.error.errors);
  }

  return {
    errors,
    clear,
    has,
    hasSub,
    get,
    setErrors,
    updateFromError,
  };
}
